import React from 'react';
import { ScrollReveal } from './ui/ScrollReveal';
import { FlowerIcon, LeafIcon, SproutIcon, TreeDeciduousIcon, WheatIcon } from 'lucide-react';
export function BotanicalStorySection() {
  return <section className="bg-white text-charcoal py-32 md:py-48 px-6 md:px-12 relative overflow-hidden" data-id="element-13">
      {/* Massive Background G - Light Theme */}
      <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-[600px] font-serif font-bold text-gray-50 opacity-50 pointer-events-none select-none z-0" data-id="element-14">
        G
      </div>

      <div className="max-w-6xl mx-auto relative z-10 text-center" data-id="element-15">
        <ScrollReveal data-id="element-16">
          <div className="flex justify-center mb-12" data-id="element-17">
            <div className="w-24 h-24 rounded-full border border-charcoal/20 flex items-center justify-center" data-id="element-18">
              <span className="font-serif text-4xl italic text-gold" data-id="element-19">Est.</span>
            </div>
          </div>
        </ScrollReveal>

        <ScrollReveal delay={0.2} data-id="element-20">
          <h2 className="text-5xl md:text-7xl font-semibold text-charcoal mb-12 tracking-tight" data-id="element-21">
            Heritage Reimagined
          </h2>
        </ScrollReveal>

        <ScrollReveal delay={0.4} data-id="element-22">
          <div className="max-w-3xl mx-auto mb-20" data-id="element-23">
            <p className="text-xl md:text-2xl leading-relaxed font-light text-gray-800" data-id="element-24">
              At Glenlofty, our philosophy is simple: to create wines that are a
              pure and authentic expression of our unique terroir. Inspired by
              the intricate woodcuts of Louis John Pouchée, our identity pays
              homage to the native flora that surrounds our vineyards, grounding
              us in the ancient landscape we call home.
            </p>
          </div>
        </ScrollReveal>

        {/* Botanical Icons Grid */}
        <div className="grid grid-cols-2 md:grid-cols-5 gap-12 md:gap-8 items-center justify-center opacity-80" data-id="element-25">
          {[{
          Icon: LeafIcon,
          label: 'Native Flora'
        }, {
          Icon: SproutIcon,
          label: 'New Growth'
        }, {
          Icon: TreeDeciduousIcon,
          label: 'Ancient Soil'
        }, {
          Icon: FlowerIcon,
          label: 'Wild Flowers'
        }, {
          Icon: WheatIcon,
          label: 'Harvest'
        }].map((item, index) => <ScrollReveal key={index} delay={0.5 + index * 0.1} data-id="element-26">
              <div className="flex flex-col items-center group" data-id="element-27">
                <div className="w-16 h-16 md:w-20 md:h-20 border border-charcoal/10 rounded-full flex items-center justify-center mb-4 transition-all duration-500 group-hover:border-gold group-hover:scale-110" data-id="element-28">
                  <item.Icon className="w-8 h-8 text-charcoal group-hover:text-gold transition-colors duration-300" strokeWidth={1} data-id="element-29" />
                </div>
                <span className="text-xs uppercase tracking-widest text-gray-500 group-hover:text-gold transition-colors" data-id="element-30">
                  {item.label}
                </span>
              </div>
            </ScrollReveal>)}
        </div>
      </div>
    </section>;
}